import 'dayjs/locale/ru'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import updateLocale from 'dayjs/plugin/updateLocale'
import weekday from 'dayjs/plugin/weekday'

export {LocaleContext} from '@yandex-taxi/go-web-components'

const DEFAULT_LOCALE = 'en'

// название некоторых пакетов в dayjs не соответствует языку из конфига
const localesMap = {
  hy: 'hy-am',
}

dayjs.extend(localeData)
dayjs.extend(updateLocale)
dayjs.extend(weekday)
dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)

const weekdaysShort = 'вс_пн_вт_ср_чт_пт_сб'.split('_')
const weekdays = 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_')

dayjs.updateLocale('ru', {
  weekdays,
  weekdaysShort,
  weekdaysMin: weekdaysShort,
  weekStart: 1,
})

export async function setLocale(locale: string) {
  locale = localesMap[locale] || locale

  await import(`dayjs/locale/${locale}.js`).catch(() => {
    // В случае ошибки или отсутствия локали, используем английскую по умолчанию
    locale = DEFAULT_LOCALE
  })

  return dayjs.locale(locale)
}
